// eslint-disable-next-line import/no-mutable-exports
let isOldWebkit = false;
if (typeof navigator !== 'undefined') {
  const result = /AppleWebKit\/([\d.]+)/.exec(navigator.userAgent);
  isOldWebkit = result && parseFloat(result[1]) < 537;
}

// на webkit < 537 не работает setSelectionRange в input,
// если в нем менялось значение через 'input.value = '...'

export default isOldWebkit;
